<template>
    <div class="thousand_layout" id="ValutBox" v-loading="loading">
        <div class="right_box">
            <div class="flex_layout_between">
                
                <h3>{{$t('vault.CardHobbyVault')}}</h3>
                <!-- <div class="flex_input">
                    <el-input ref="ifSellingCounts" :placeholder="$t('alert.searchWatchlist')" v-model="sn"
                        class="input-with-select" @change="getWatchlist">
                    </el-input>
                    <el-button slot="append" @click="getWatchlist" icon="el-icon-search"></el-button>
                </div> -->
            </div>
            <div class="breadcrumb">
                <router-link class="text_gray" :to="{ path: '/vault/buyerpanel' }">{{$t('vault.CardHobbyVault')}}</router-link> 
                <span class="el-icon-arrow-right text_gray"></span> 
                {{$t('vault.WithdrawfromVault')}}</div>
            <div class="bids_tabs">
                <div><router-link :to="{ path: '/vault/StockInMgt/'+vaultWareId }">{{$t('vault.SubmittoVault')}}</router-link></div>
                <div><router-link :to="{ path: '/vault/myvault/'+vaultWareId }">{{$t('vault.InVault')}}</router-link></div>
                <div class="on"><router-link :to="{ path: '/vault/OutboundList/'+vaultWareId}">{{$t('vault.WithdrawfromVault')}}</router-link></div>
            </div>
            <div class="flex_layout_between">
                <div class="status_tabs">
                    <span :class="{ 'active': !PickupStatus }" v-on:click="PickupStatus = 0">{{$t('base.all')}}</span>
                    <!-- <span :class="{ 'active': PickupStatus == 1 }" v-on:click="PickupStatus = 1">待支付</span> -->
                    <span :class="{ 'active': PickupStatus == 2 }" v-on:click="PickupStatus = 2">{{$t('vault.AwaitingShipment')}}</span>
                    <span :class="{ 'active': PickupStatus == 3 }" v-on:click="PickupStatus = 3">{{$t('vault.Shipped')}}</span>
                    <!-- <span :class="{ 'active': PickupStatus == 4 }" v-on:click="PickupStatus = 4">待提货</span> -->
                    <span :class="{ 'active': PickupStatus == 5 }" v-on:click="PickupStatus = 5">{{$t('vault.Completed')}}</span>
                </div>
            </div>
            <div class="vault_list_box outbund">
                <div class="headlist">
                    <div class="first">{{ $t('base.item') }}</div>
                    <div>{{ $t('base.quantity') }}</div>
                    <div>{{ $t('base.shippingFee') }}</div>
                    <div>{{ $t('base.status') }}</div>
                    <div>{{ $t('base.operate') }}</div>
                </div>
                <div class="content_list" v-for="(item, index) in valutList" v-bind:key="index">
                    <div class="first">
                        <div class="pickupCard" v-for="(res, i) in item.CardCommodities" v-if="i<=2" :key="i" :class="['pickupCard'+i]">
                            <div class="pickupCardImg">
                                <img class="img-box" :src="res.TitImg + '?imageView2/2/w/350'"
                                    style="max-width: 100%; object-fit: contain; " :alt="res.Title">
                                <span class="col-xs-5 tag" v-if="item.HasException && res.CardException&&i==0">{{res.CardException.ExceptionTypeName }}</span>
                            </div>
                            <div class="pickupCardText" v-if="i==0">
                                <strong class="line-clamp-2">{{ res.Title }}</strong>
                                <div>{{ res.StarCardSku.ProfessionalGrader }} {{ res.StarCardSku.Grade }}</div>
                            </div>
                        </div>
                    </div>
                    <div>x {{ item.CardCommodities.length }}</div>
                    <div>
                        USD 0.00
                    </div>
                    <div>{{PickupStatusMsg[item.PickupStatus]}}</div>
                    <div class="last">
                        <router-link class="operate-side flex" :to="{ path: '/vault/OutboundDetail/'+item._id }">{{$t('base.viewDetails')}}</router-link>
                        <router-link class="operate-side flex" :to="{ path:`/mycardhobby/warehouse`}" v-if="item.PickupStatus==5">{{$t('vault.ForwardtoWarehouse')}}</router-link>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
// import vueVault from './js/vue-Vault.js';

import { getInfo } from "@/api/public";
export default {
    data() {

        return {
            userInfo:getInfo(),
            loading:false,
            PageIndex: 1,
            PageSize: 20,
            isCount: false,
            valutList: {},
            pageTotal: '',
            PickupStatus: 0,//出库状态集合    待支付  = 1, 	待寄出 = 2, 	已寄出 = 3, 	待提货 = 4, 	已完成 = 5, 	已取消 = 6,
            PickupType: '',//提货类型 寄回 = 0, 门店自提 = 1, 转运仓=3
            vaultWareId: '',
            
        }
    },
    watch: {
        'PickupStatus': {
            immediate: true,
            handler(obj) {
                this.loading=true
                //console.log(obj,'locationOption')
                this.PageIndex=1;
                this.getPickupApplyByPage()
            }
        }
    },
    created: function () {
        
        const that = this;
        if(that.$route.params.id){
            that.vaultWareId= that.$route.params.id
        }


    },
    mounted: function () {
        var that = this;
    },
    computed: {
        PickupStatusMsg(){
            return {
                2: this.$t('vault.AwaitingShipment'),
                3: this.$t('vault.Shipped'),
                5: this.$t('vault.Completed')
            }
        }
    },
    methods: {
        //出库列表
        getPickupApplyByPage() {
            const that = this;
            var parm = {
                memberId: that.userInfo.MappingUserId,
                PickupStatus: that.PickupStatus ? [that.PickupStatus] : [],
                PickupType: that.PickupType,
                PageIndex: that.PageIndex,
                PageSize: that.PageSize
            }
            that.$post(this.$interface.GetPickupApplyByPage, parm).then(res => {
                if (res.Result > 0) {
                    that.isCount = false
                    
                    that.pageTotal = res.Count
                        that.valutList = res.Data;
                    if (res.Count < 0) {
                        that.isCount = true
                    }
                } else {
                    that.isCount = true

                }
                
                this.loading=false
            })

        },



        /*数据请求*/
        getData(api, data = '', key) {
            var that = this;
            var fun = "", method = "GET";
            switch (api) {
                case 'GetCommodityByMemberId':
                    /* 在库未上架列表 */
                    that.loading = true;
                    that.tabType = 2
                    fun = function (res) {
                        //that.vaultType = 0
                        //console.log('GetCommodityByMemberId',res)
                        if (res.Result > 0) {
                            that.isCount = false
                            if (res.Count > 0) {
                                that.pageTotal = res.Count
                                if (data == 'stacking') {
                                    if (res.Data.length > 0) {
                                        that.valutList = [...that.valutList, ...res.Data];
                                    } else {
                                        that.noMore = true;
                                    }
                                } else {
                                    that.noMore = false;
                                    that.valutList = res.Data;
                                    that.stockFrom.ValutId = res.Data[0].ValutId
                                }
                            } else {
                                that.isCount = true
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = {
                        MemberId: that.MemberId,
                        Status: that.Status,
                        Title: that.Title,
                        SellerUserId: that.SellerUserId,
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        SortBy: null,//当前价格=1   截标时间=2    不传或者传null 为默认排序
                        SortType: 1//正序=1  倒序=-1 不传或者传null 为默认排序
                    }

                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    })
                    break;
                case 'SearchCommodities':
                    /* 在库已上架列表 */
                    that.loading = true;
                    fun = function (res) {
                        //that.vaultType = 1
                        if (res.Result > 0) {
                            that.isCount = false
                            if (res.Count > 0) {
                                that.pageTotal = res.Count
                                that.noMore = false;
                                that.valutList = res.Data;
                            } else {
                                that.isCount = true
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = `?MemberId=${that.MemberId}&SortType=${that.SortType}&ByWay=${that.byWay}&ListType=${that.listType}&SearchKey=${that.Title}&PageIndex=${that.PageIndex}&PageSize=${that.PageSize}`
                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    })
                    break
                case 'GetCommodityById':
                    /* valut商品详情 */
                    that.loading = true;
                    fun = function (res) {
                        //console.log('GetCommodityById-res', res)
                        if (res.Result > 0 && res.Data) {
                            let _data = res.Data
                            that.imgUrl = _data.TitImg
                            var tPrice = _data.Price || _data.EstimatePrice
                            _data.maxPrice = commonEventJs.numMulti(tPrice, _data.MaxPriceRatio)

                            if (_data.maxPrice <= 1) {
                                _data.maxPrice = 1
                            } else {
                                _data.maxPrice = Math.ceil(_data.maxPrice)
                            }
                            that.commodityDetail = _data
                            /* 评级表格 */
                            that.getBabyData(_data)
                            /* 倒计时 */
                            try {
                                //_data.EffectiveTime = "2026-5-1 18:18:00"
                                if (_data.EffectiveTime) {
                                    that.getCountDown(_data)
                                }
                            } catch (e) { }
                            //that.vaultTitle = "Vault识别码：" + _data.Code
                            that.GetDetailCommodity(_data);
                            that.dialogShow = true;
                        } else {
                            //that.$message.error("获取商品详情失败");
                        }
                        that.loading = false;
                    }
                    //console.log("GetCommodityById", api, parm)
                    that.$get(that.$interface[api], data).then(res => {
                        fun(res)
                    });
                    break
                case 'GetNewCommodityByCodeScore':
                    /* 评级表格 */
                    that.loading = true;
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.codeScore = res.Data;
                        }
                        that.loading = false;
                    }
                    var parm = data
                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'ReleaseCommodity':
                    /* 从valut仓上架 */
                    that.loading = true;
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.$message(res.Msg);
                            that.dialogShow = false;
                            that.getData('GetCommodityByMemberId')
                        } else {
                            that.$message.error(res.Msg);
                        }
                        that.loading = false;
                    }
                    var parm = data
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'GetStoreListByPageApp':
                    /* 获取门店列表 */
                    fun = function (res) {
                        if (res.Result > 0) {
                            let _data = res.Data
                            /* 剔除海外门店与港澳台门店 */
                            let verifyCode = '香港,台湾,澳门'
                            that.storeList = _data.filter(item => item.Province == '中国' && (verifyCode.indexOf(item.City) < 0))
                            that.setAddress(that.storeList[0])
                            try {
                                $.cookie('storeList', 0, { expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), path: "/" });
                                window.localStorage.setItem('storeList', JSON.stringify(that.storeList));
                            } catch (e) { }
                        }
                    }
                    var parm = { PageIndex: 1, PageSize: 999, StoreType: "0" }
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'PickupApplyAdd'://提货申请
                    that.noButton = true
                    that.pickupLoading = true;
                    fun = function (res) {
                        console.log('PickupApplyAdd-res', res);
                        if (res.Result > 0) {
                            that.$message('提货成功');
                            window.location.href = '/order/OutboundDetail/' + res.Data
                        } else {
                            that.$message.error(res.Msg);
                            that.noButton = false
                            that.pickupLoading = false;
                        }
                    }
                    var parm = data
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'GetPickupApplyByPage': //出库列表
                    fun = function (res) {
                        that.vaultType = 3
                        that.tabType = 3
                        if (res.Result > 0) {
                            that.isCount = false
                            if (res.Count > 0) {
                                that.pageTotal = res.Count
                                that.noMore = false;
                                res.Data.map(item => {
                                    item.isMore = false;
                                    try {
                                        if (item.CardCommodities && item.CardCommodities.length > 2) {
                                            item.isMore = true;
                                        }
                                    } catch (e) { }
                                })
                                that.valutList = res.Data;
                            } else {
                                that.isCount = true
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = {
                        memberId: that.MemberId,
                        PickupStatus: that.PickupStatus ? [that.PickupStatus] : [],
                        PickupType: that.PickupType,
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize
                    }
                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'GetPickupApplyById': //出库详情
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.orderDetail = res.Data
                            if (res.Data && res.Data.Code) {
                                var pram = "&customField={ \"OrderNo\":\"" + res.Data.Code + "\",\"Phone\":\"" + that.MemberMobile + "\",\"NickName\":\"" + that.MemberRealName + "\",\"问题来源\":\"卡淘Vault\"}&otherParams ={\"peerId\":\"10068483\", \"NickName\":\"" + that.MemberRealName + "\"}&urlTitle = 卡淘Vault"
                                that.url = that.url + pram
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = {
                        Id: that.orderId,
                    }
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break

                case 'GetExpressSubscribeInfo'://提货申请查询物流
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.isExpress = true;
                            that.expressDetail = res.Data[0].Tracklist
                        }
                    }
                    var parm = data
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'getAddresList'://获取收货地址
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.addressList = res.Data
                            that.setAddress(res.Data[0])
                        }
                    }
                    that.$get(that.$interface['getAddressList'], '').then(res => {
                        fun(res)
                    });
                    break
                case 'GetSeller':
                    that.loading = true;
                    fun = function (res) {
                        if (res.Result > 0) {
                            var _data = res.Data
                            //是否开通钱包 未开通 0，开通 1，商家升级 2，审核中 3，升级失败 4，银行卡失败 5
                            if (_data && _data.AdapayStatus == 3 && _data.IsUploaded == 1) {
                                /* 企业升级中--链接至入驻企业界面 */
                                that.isWallet = 2
                            } else if (_data && (_data.AdapayStatus == 1 || _data.AdapayStatus == -2)) {
                                /* 钱包审核中 */
                                that.isWallet = 3
                            } else if (_data && (_data.AdapayStatus == -3 || _data.AdapayStatus == -4 || _data.AdapayStatus == -5) && _data.IsUploaded == 1) {
                                /* 企业失败中--链接至入驻企业界面 uploadedLink */

                                that.isWallet = 4
                            } else if (_data && _data.AdapayStatus == -7) {
                                /* 更换银行卡失败 walletLink*/
                                that.isWallet = 5
                            } else {
                                /* 未开通钱包 - 链接至开通钱包 walletLink */
                                that.isWallet = 0
                            }
                        }
                        that.loading = false;
                    }
                    var parm = `?id=${that.MemberId}&token=${that.token}`
                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break;
                case 'GetWalletInfo'://获取钱包信息
                    that.loading = true;
                    fun = function (res) {
                        //console.log("GetWalletInfo", res);
                        if (res.Result) {
                            var _data = res.Data;
                            that.isWallet = _data.OpenWallet ? 1 : 0;
                            that.errorMsg = _data.ErrorMsg
                            if (!_data.OpenWallet) {
                                that.getData('GetSeller')
                            }
                        }
                        that.entrustSaleBtnShow = true;
                        try {
                            const urlParams = that.urlParams;
                            const pageFrom = urlParams.get('f');
                            if (pageFrom == 'panel') {
                                that.entrustSaleDialog()
                            }
                        } catch (err) { }
                        that.loading = false;
                    }
                    var parm = `?id=${that.MemberId}&token=${that.token}`
                    // that.$get(that.$interface[api], parm).then(res => {
                    //     fun(res)
                    // });
                    fun({ Result: 1, Data: { OpenWallet: true } })
                    break;
                //case 'GetVaultSoldLog':
                //    that.vaultType = 4
                //    that.loading = true;
                //    fun = function (res) {
                //        if (res.Result > 0) {
                //            that.valutList = res.Data;
                //        }
                //        that.loading = false;
                //    }
                //    var parm = {
                //        id: that.MemberId,
                //        status:'21',
                //        pageindex: that.pageindex
                //    }
                //    commonEventJs.Request(api, parm, fun, 'POST');
                //    break;
                case 'GetNewDocment'://获取协议内容
                    //提货说明 type = 22

                    that.loading = true;
                    fun = function (res) {
                        //console.log("GetNewDocment", res);
                        if (res.Result) {
                            var _data = res.Data;
                            that.IsAgree = _data.IsAgree
                            that.AgreementFormData.UserId = that.MemberId
                            that.AgreementFormData.ServiceAgreementId = _data.ID
                            that.AgreementFormData.ServiceAgreementType = _data.ServiceAgreementType
                            that.AgreementFormData.AreaId = _data.AreaId
                            that.AgreementFormData.VersionNo = _data.VersionNo
                        }
                        that.loading = false;
                    }
                    var parm = `?ServiceAgreementType=21&memberId=${that.MemberId}`
                    that.$get(that.$interface['GetNewServiceAgreements'], parm).then(res => {
                        fun(res)
                    });
                    break;
                case 'SetServiceAgreementLog':
                    that.loading = true;
                    fun = function (res) {
                        if (res.result == 1) {
                            that.IsAgree = true
                        }
                        that.loading = false;
                    }
                    var parm = that.AgreementFormData
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break;
                default:
                    break;
            }
        },
        GetDetailCommodity(data) {
            let that = this;
            //console.log("GetDetailCommodity", data);
            const parm = {
                "CommodityID": data.CardId,
                "memberid": that.MemberId,
                "operator_id": that.MemberId,
                "token": that.token,
                "device": "Web",
                "lag": "zh",

            }
            const fun = function (res) {
                //console.log("GetDetailCommodity-res",res);
                if (res.Result == 1) {
                    //关注数... 浏览量...
                    that.cardDetail = res.Data;
                    try {
                        if (res.Data.EffectiveTime) {
                            that.getCountDown(that.cardDetail)
                        }
                    } catch (e) { }
                    //that.commodityDetail = {...res.Data }
                } else { }
            }
            that.$get(that.$interface['GetDetailCommodity'], parm).then(res => {
                fun(res)
            });
        },
        getExpress() {
            let that = this
            var _data = {
                OrderId: that.orderDetail._id,
                ShipperCode: that.orderDetail.LogisticsCompanyCode, //公司编号
                LogisticCode: that.orderDetail.TrackingNumber //公司编号
            }
            that.getData('GetExpressSubscribeInfo', _data)
        },
        /* 评级框架 */
        getBabyData(obj) {
            let that = this
            let _data = obj.StarCardSku
            //let data = `?id=${obj.ValutId}`
            if (_data) {
                try {
                    if (_data.CertificationNumber && _data.ProfessionalGrader && obj.FirstCategoryId) {
                        var _code = _data.CertificationNumber.replace(/[^a-zA-Z0-9]/g, "");///去所有特殊符号: /[^a-zA-Z0-9]/g    只保留数字: /\D/g   只去#: /#/g
                        let data = `?code=${_code}&companyCode=${_data.ProfessionalGrader}&category=${obj.FirstCategoryId}`
                        that.getData('GetNewCommodityByCodeScore', data)
                    }
                } catch (e) {
                }
            }
        },
        /* 获取门店列表 缓存有就拿缓存，没有就调接口 cookie存一天 */
        getStoreList() {
            let that = this
            let isCookie = $.cookie('storeList')
            if (isCookie) {
                let _data = window.localStorage.getItem('storeList')
                try {
                    _data = JSON.parse(_data)
                    that.storeList = _data
                    that.setAddress(_data[0])

                } catch (e) {
                    that.getData('GetStoreListByPageApp');
                }
            } else {
                that.getData('GetStoreListByPageApp');
            }
        },
        /* 倒计时 */
        getCountDown(obj) {
            var id = obj.ID || obj._id;
            $.get("/market/_countdown/" + id + "?endDate=" + obj.EffectiveTime + "&" + Math.random(), function (data) {
                $(".count").html(data);
            })
        },
        /* 上架 */
        releaseCard(obj) {
            let that = this
            if (that.effectiveDay) {
                let commodityId = obj._id || obj.Id
                let _data = {
                    memberId: that.MemberId,
                    commodityId: commodityId,
                    byWay: 2,
                    price: that.startPrice,
                    isDeposit: 0,
                    EffectiveTime: that.effectiveDay
                }
                //console.log(_data, '_data', that.isWallet, that.IsAgree)

                if (that.vaultType == 0 && (that.isWallet != 1 || !that.IsAgree)) {
                    //未上架 没开通电子钱包或没同意XX协议
                    //await that.getData('GetWalletInfo')
                    //await that.getData('GetNewDocment')
                    that.setMessageBox()
                } else {
                    that.getData('ReleaseCommodity', _data);
                }
            } else {
                that.$message.error('请选择竞价持续时间');
            }
        },
        getPickup() {
            let that = this
            let _data = {
                memberId: that.MemberId,
                PageIndex: that.PageIndex,
                PageSize: that.PageSize
            }
            that.getData('GetPickupApplyByPage', _data)
        },
        /* 获取valut仓商品详情 */
        getDetail(obj, val) {
            //console.log(obj, val)
            let that = this
            let _data = `?Id=${[0, 5].includes(that.vaultType) ? obj.Id : obj.ValutCommodityId}`
            if (val) {
                _data = `?Id=${obj._id}`
            }
            //console.log(_data, 'val')
            that.getData('GetCommodityById', _data)
        },
        getValut(val) {
            let that = this
            that.PageIndex = 1
            that.noMore = false;
            if ([0, 5].includes(val)) {
                that.getData('GetCommodityByMemberId');
            }
            if ([1, 2].includes(val)) {
                that.getData('SearchCommodities');
            }
            //if (val == 4) {
            //    that.getData('GetVaultSoldLog');
            //}

        },
        isStartPrice() {
            let that = this
            if (that.startPrice) {
                that.startPrice = Math.trunc(that.startPrice)
                if (that.startPrice <= 1) {
                    that.startPrice = 1
                }
                if (that.startPrice >= commodityDetail.maxPrice) {
                    that.startPrice = commodityDetail.maxPrice
                }
            } else {
                that.startPrice = 1
            }
        },
        infiniteValutList() {
            let that = this
            console.log('infiniteValutList', that.noMore, that.vaultType)
            if (!that.noMore) {
                that.PageIndex += 1;
                that.SortBy = ''; // 当前价格=1   截标时间=2    不传或者传null 为默认排序
                that.SortType = -1; //正序=1  倒序=-1 不传或者传null 为默认排序
                if (that.vaultType == 0) {
                    that.getData('GetCommodityByMemberId', 'stacking');
                }
                //else if (that.vaultType == 1) {
                //    that.getData('SearchCommodities', 'stacking');
                //}
            }
        },
        checkListVal(e) {
            let that = this
            //console.log('checkListVal', e, that.checkList)
        },
        /* 设置用户地址 */
        setAddress(obj) {
            let that = this
            if (that.stockFrom.PickupType == 0) {
                /* 用户收货地址 */
                that.userAddress = obj
                that.stockFrom.ReceiverName = obj.Consignee
                that.stockFrom.receiverPhone = obj.Mobile
                that.stockFrom.ProvinceName = obj.Provice
                that.stockFrom.receiverAddress = obj.Address
            }
            if (that.stockFrom.PickupType == 1) {
                that.userAddress = obj
                that.stockFrom.ReceiverName = obj.StoreName
                that.stockFrom.receiverPhone = obj.StorePhone
                that.stockFrom.ProvinceName = obj.City
                that.stockFrom.receiverAddress = obj.City + (obj.District || '') + obj.Address
                that.stockFrom.StoreId = obj._id
            }
        },
        GetPickupStatus(val) {
            //出库状态集合    待支付  = 1, 	待寄出 = 2, 	已寄出 = 3, 	待提货 = 4, 	已完成 = 5, 	已取消 = 6,
            let text = ''
            switch (val) {
                case 1:
                    text = '待支付';
                    break
                case 2:
                    text = '待寄出';
                    break
                case 3:
                    text = '已寄出';
                    break
                case 4:
                    text = '待提货';
                    break
                case 5:
                    text = '已完成';
                    break
                case 6:
                    text = '已取消';
                    break
                default:
                    break;

            }
            return text
        },
        /* 切换图片 */
        viewImg(item) {
            this.imgUrl = item.ImageUrl
        },
        /* 切换提货渠道  个人或门店 */
        viewOutBoundTab(val) {
            var that = this;
            that.stockFrom.PickupType = val
            that.stockFrom.ConsigneeName = ''
            that.stockFrom.ConsigneePhone = ''
            if (val == 0) {
                that.getData('getAddresList');
            }
            if (val == 1) {
                that.getStoreList();
            }
        },
        pickupApplyAdd() {
            var that = this;
            var _data = that.stockFrom;
            _data.CardIds = that.checkList
            console.log('pickupApplyAdd_data', _data,)
            console.log('pickupApplyAdd_checkList', that.checkList)
            if (that.pickupLoading) return
            if (that.stockFrom.PickupType == 1) {
                //手机号验证
                that.$refs['stockFrom'].validate((valid) => {
                    if (valid) {
                        that.getData('PickupApplyAdd', _data);
                    } else {
                        return ''
                    }

                })
            } else {
                that.getData('PickupApplyAdd', _data);
            }
            //
        },
        /* 商品上架前，弹框 */
        checkUserWallet() {
            var that = this;
            //是否开通钱包 未开通 0，开通 1，商家升级 2，审核中 3，升级失败 4，银行卡失败 5
            var tipMsg = '';
            switch (that.isWallet) {
                case 0:
                    //tipMsg = '未开通电子账户';
                    break
                case 2:
                    tipMsg = '商家升级中';
                    break
                case 3:
                    tipMsg = '审核中';
                    break
                case 4:
                    tipMsg = '企业升级失败';
                    break
                case 5:
                    tipMsg = '银行卡更换失败';
                    break
                default:
                    break;

            }
            var html = `<ul><li class='on'>委托代卖成交后，货款将自动转入电子账户</li>`;
            html += tipMsg ? `<li>当前状态：<span style="color:#f40">${tipMsg}</span></li>` : '';
            html += `</ul>`;
            that.$confirm(html, '请开通电子账户', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: that.isWallet === 0 ? '去开通' : '查看',
                cancelButtonText: '取消',
            }).then(() => {
                if (that.isWallet === 0) {
                    window.open(that.walletLink, "_blank")
                } else {
                    window.location.href = "/verify/Wallet"
                }
            })
        },
        setMessageBox() {
            var that = this;
            var html = `<ul>
                <li class='on'>1、开通卡淘电子账户</li>
                <li>2、阅读并同意<a href="/Market/Article?serviceAgreementType=21" target="_blank">《卡淘Vault寄存卡牌代卖协议》</a></li>
            </ul>`
            var confirmText = that.isWallet == 1 ? '同意' : '去开通'
            that.$confirm(html, '商品上架前，请完成以下步骤', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: confirmText,
                cancelButtonText: '取消',
            }).then(() => {

                if (that.isWallet != 1) {
                    //是否开通钱包 未开通 0，开通 1，商家升级 2，审核中 3，升级失败 4，银行卡失败 5
                    switch (that.isWallet) {
                        case 0:
                            if (that.errorMsg) {
                                that.$message.error(that.errorMsg);
                            }
                            setTimeout(function () {
                                window.location.href = that.walletLink
                            }, 1000)
                            break
                        case 2:
                            that.$message.error('商家升级');
                            break
                        case 3:
                            that.$message.error('审核中');
                            break
                        case 4:
                            that.$message.error('企业升级失败');
                            setTimeout(function () {
                                window.location.href = that.uploadedLink
                            }, 1000)
                            break
                        case 5:
                            that.$message.error('银行卡更换失败');
                            setTimeout(function () {
                                window.location.href = that.walletLink + '&changebank=1'
                            }, 1000)
                            break
                        default:
                            that.$message.error('未开通');
                            break;

                    }
                } else {
                    //阅读并同意 xxx条约 
                    that.IsAgree = true
                    that.getData('SetServiceAgreementLog');
                }
            })
        },



        /* 分页*/

        getCurrent(val) {
            var that = this;
            if ([0, 5].includes(that.vaultType)) {
                that.getData('GetCommodityByMemberId')
            }
            if ([1, 2].includes(that.vaultType)) {
                that.SortType = val
                that.getData('SearchCommodities')
            }
            if (that.vaultType == 3) {
                that.PickupStatus = val
                that.getData('GetPickupApplyByPage')
            }
        },
        currentChange(val) {
            var that = this;
            that.PageIndex = val;
            that.getCurrent()
            //that.getData('WalletRecordByPage');
            //console.log(`当前页: ${val}`);
        },
        sizeChange(val) {
            var that = this;
            that.PageIndex = 1;
            that.PageSize = val;
            that.getCurrent()
            //that.getData('WalletRecordByPage');
            //console.log(`每页 ${val} 条`);
        },
        //委托代卖
        GetStartBidRatio() {
            //获取起拍价比例
            const that = this;
            var parm = {}
            const fun = function (res) {
                //console.log("GetStartBidRatio",res)
                if (res.Result == 1) {
                    that.DetailStartBid = res.Data
                } else {
                }
            }
            that.$get(that.$interface['GetStartBidRatio'], parm).then(res => {
                fun(res)
            });
        },
        GetCategoriesV1() {
            const that = this;
            let result = Categories.GetCategoriesList[0].FirstCategory;
            const SecondCategories = result.SecondCategories;
            SecondCategories.map(item => {
                const data = {
                    Id: item.Category._id,
                    ChName: item.Category.ChName,
                    EnName: item.Category.EnName,
                    IsEnable: false
                };
                that.CategoryLabels = [...that.CategoryLabels, data];
            });
        },
        UpdateApplyStatus(obj) {
            //修改代卖卡状态 撤销代卖
            var that = this;
            if (that.updateStatusloading) return;
            that.$confirm(`确认撤销该商品代卖`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.updateStatusloading = true;
                var parm = { SellerApplyIds: [obj.SellerApplyId], ApplyStatus: 4 }
                const fun = function (res) {
                    //console.log("UpdateApplyStatus",res)
                    if (res.Result == 1) {
                        that.getData('GetCommodityById', `?Id=${obj._id}`)
                        that.getData('GetCommodityByMemberId')
                        that.GetSellingList()
                        setTimeout(function () {
                            that.updateStatusloading = false;
                        }, 2000)
                    } else {
                        that.updateStatusloading = false;
                    }
                }
                /*
                    ApplyStatus: 申请状态 0 待审核 1 审核通过 3审核驳回  4 卡主撤销代卖
                */
                that.$post(that.$interface['UpdateApplyStatus'], parm).then(res => {
                    fun(res)
                });
            }).catch(() => { });
        },
        entrustSaleDialog(prams = {}) {
            const that = this;
            //是否开通钱包 未开通 0，开通 1，商家升级 2，审核中 3，升级失败 4，银行卡失败 5
            //that.isWallet = 0;
            const isWallet = that.isWallet;
            if (isWallet != 1) {
                that.checkUserWallet();
                return;
            }
            this.dialogEntrustSaleVisible = true;
            this.GetSellerList(prams);
        },
        handleEntrustSaleClose() {
            this.dialogEntrustSaleVisible = false;
            this.cSellerIndex = -1;
            this.currentSeller = {};
            this.entrustProcess = 1;//选择委托代卖流程 1：选择商家 2：选择商品  3：确认提交

            this.isIndeterminate = false;
            this.checkedList = [];
            this.checkAll = false;
            this.complyGoodsList = [];//符合代卖人的商品列表
            this.submitApplyLoading = false;
            this.vaultAgreement = false;
        },
        handleEntrustBack(val) {
            this.entrustProcess = val || 1;
            switch (val) {
                case 1:
                    this.checkedList = []
                    this.isIndeterminate = false
                    this.checkAll = false
                    break;
                case 2:
                    this.vaultAgreement = false
                    break;
                default:
                    break;
            }
        },
        handleEntrust(val, nextStatus = false) {
            //委托代卖 - 处理流程 选择、确认
            const that = this;
            if (!nextStatus) return;
            if (val == 'submit') {
                //console.log('submit')
                //提交委托申请
                if (that.checkedList.length <= 0) {
                    that.$confirm(`请先选择需委托的商品`, '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                } else {
                    that.$confirm(`确认提交委托申请`, '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'info'
                    }).then(() => {
                        if (that.submitApplyLoading) return;
                        that.submitApplyLoading = true;
                        // commonEventJs.signAgreement(that.vaultAgreementType);//提交协议

                        let CommodityIds = that.checkedList.map(item => item._id);
                        const currentSeller = that.currentSeller;
                        var parm = {
                            ...that.FormDataApply,
                            CommodityIds,
                            SellerMemberId: currentSeller.MemberId,
                            SellerRealName: currentSeller.RealName
                        }
                        const fun = function (res) {
                            if (res.Result == 1) {
                                that.$message.success('申请成功');
                                that.handleEntrustSaleClose();
                                that.getData('GetCommodityByMemberId');
                                that.GetSellingList()
                                setTimeout(() => {
                                    that.submitApplyLoading = false;
                                    if (that.CardApplyType == 'SingleCardApply') {
                                        that.currentCategoryId = null;
                                        that.dialogShow = false;
                                    }
                                }, 1000)
                            } else {
                                that.$message.error('申请失败：' + res.Msg);
                                that.submitApplyLoading = false;
                            }
                        }
                        that.$post(that.$interface['SaveSellerApply'], parm).then(res => {
                            fun(res)
                        });
                    }).catch(() => { });
                }
            } else {
                if (that.CardApplyType == 'SingleCardApply') val = 3;//单卡委托 跳过选择商品
                that.entrustProcess = val || 1;
                if (val === 2) {
                    that.GetCardCommodityByPage();
                }
            }

        },
        GetSellerList(parms = {}) {
            //获取商户列表
            const that = this;
            that.searchLoading = true;
            const fun = function (res) {
                //console.log("GetSellerUserByPage",res)
                if (res.Result == 1) {
                    that.sellerList = res.Data || [];
                }
                that.searchLoading = false;
            }
            var parm = { pageIndex: 1, pageSize: 999, LoginMemberId: that.MemberId, ...parms }
            that.$post(that.$interface['GetSellerUserByPage'], parm).then(res => {
                fun(res)
            });

        },
        GetSellingList() {
            //我已委托的代卖商品，代卖筛选列表
            const that = this;
            if (that.sellingList.length) return;
            const fun = function (res) {
                //console.log("GetSellingList",res)
                if (res.Result == 1) {
                    that.sellingList = res.Data || [];
                }
            }
            var parm = { pageIndex: 1, pageSize: 999, MemberId: that.MemberId }
            that.$get(that.$interface['GetSellingList'], parm).then(res => {
                fun(res)
            });
        },
        checkType(id, item) {
            const that = this;
            this.currentCategoryId = id
            console.log('checkType', id, item)
            this.GetSellerList({ CategoryId: id });
        },
        selectSeller(obj, key) {
            //勾选代卖
            const that = this;
            if (obj.OnlineStatus === 0) return;
            that.cSellerIndex = key;
            that.currentSeller = obj;
        },
        toggleCommission(type) {
            this.commissionShow = type;
        },
        GetCardCommodityByPage() {
            //获取符合代卖的商品列表
            const that = this;
            const currentSeller = that.currentSeller;
            const Categorys = currentSeller.Categorys || [];
            let CategoryIds = [];
            if (Categorys.length) {
                CategoryIds = Categorys.map(item => item.Id);
            }
            var parm = {
                ...that.seachComplyGoodsForm,
                CategoryIds,
                AmountLimit: -1,//金额限定 -1 无限制
            }
            const fun = function (res) {
                if (res.Result == 1) {
                    that.complyGoodsList = res.Data || [];
                    that.seachPageTotal = res.Count || 0;
                } else {
                    that.complyGoodsList = [];
                    that.seachPageTotal = 0;
                }
            }
            that.$post(that.$interface['GetCardCommodityByPage'], parm).then(res => {
                fun(res)
            });
        },
        seachSizeChange(val) {
            //console.log(`每页 ${val} 条`);
            const that = this;
            this.checkedList = [];
            this.checkAll = 0;
            this.isIndeterminate = false;

            that.$set(that.seachComplyGoodsForm, 'PageSize', val);
            that.GetCardCommodityByPage();
        },
        seachCurrentChange(val) {
            //console.log(`当前页: ${val}`);
        },
        handleCheckAllChange(val) {
            let CategoryIds = [];
            if (this.complyGoodsList.length) {
                CategoryIds = this.complyGoodsList.map(item => item._id);
            }
            this.checkedList = val ? this.complyGoodsList : [];
            this.isIndeterminate = false;
            //console.log("checkedList",this.checkedList)
        },
        handleCheckedChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.complyGoodsList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.complyGoodsList.length;
            //console.log("checkedList",this.checkedList)
        },
        handleVaultAgreement() {
            //console.log('vaultAgreement',this.vaultAgreement)
        },
        //单卡委托
        SingleCardApply(item) {
            const that = this;
            //console.log('SingleCardApply', item)
            console.log('SingleCardApply-prams', item, item.SecondCategoryName, item.SecondCategoryId, item.EstimatePrice)
            that.CardApplyType = 'SingleCardApply';
            that.currentCategoryId = item.SecondCategoryId;
            that.checkedList = [{ ...item }]
            that.entrustSaleDialog({ CategoryId: item.SecondCategoryId, AmountLimit: item.EstimatePrice })
        },
        //同意协议
        ifAgreement(agreeId) {
            let isAgree = true;// !this.vaultAgreement;
            if (!this.vaultAgreement) {
                this.vaultAgreement = isAgree;
            }
        }
    },
    destroyed: function () {
        var that = this;
    }
};
</script>


<style scoped>
@import "../../../static/css/usertabslist.css";
@import "../../../static/css/vault/vault.css";

.img-box{
    border-radius: 5px;
    background: #f5f7fa;
    border: 1px solid #e5e5e5;
}
.first{
    position: relative;
}
.pickupCard{
    position: relative;
    z-index: 3;
}
.pickupCard+.pickupCard {
    position: absolute;
    width: 100px;
    display: block;
}
.pickupCard1{
    left: 4px;
    top: 4px;
    z-index: 2;
}
.pickupCard2{    
    left: -4px;
    top: 8px;
    z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/pages/Vault/VaultOutbound.vue